const path = '/base/escola';

const endpoint = {
  main: path,
};

export default endpoint;
